import type { QueryClient } from "@tanstack/react-query";
import { toast } from "@volca/ui/lib/toast";
import { aiScriptSpreadsheetKey } from "@/payroll/ai-script/query";
import { isAiScriptWorkbookAuthorizationError } from "@/payroll/ai-script/utils";
import {
  getWorkbookMutationErrorFeedback,
  type WorkbookMutationErrorFeedback,
} from "./cell-edit-feedback";

interface CreateMutationErrorHandlersParams {
  queryClient: QueryClient;
  businessId: string | null;
  runId: string;
}

export const createMutationErrorHandlers = ({
  queryClient,
  businessId,
  runId,
}: CreateMutationErrorHandlersParams) => {
  const showMutationErrorFeedback = (
    feedback: WorkbookMutationErrorFeedback,
  ) => {
    if (
      feedback.error instanceof Error &&
      feedback.error.name === "AbortError"
    ) {
      return;
    }

    if (isAiScriptWorkbookAuthorizationError(feedback.error)) {
      queryClient.invalidateQueries({
        queryKey: aiScriptSpreadsheetKey(businessId, runId),
      });
    }

    toast.error(feedback.title, {
      description: feedback.description,
      id: feedback.id,
    });
  };

  const handleMutationError = (title: string, mutationError: unknown) =>
    showMutationErrorFeedback(
      getWorkbookMutationErrorFeedback(title, mutationError),
    );

  return { showMutationErrorFeedback, handleMutationError };
};

export type MutationErrorHandlers = ReturnType<
  typeof createMutationErrorHandlers
>;
